import React, { createContext, useContext, useState } from 'react';

const FeedbackContext = createContext();

export const useFeedback = () => {
  const context = useContext(FeedbackContext);
  if (!context) {
    throw new Error('useFeedback must be used within a FeedbackProvider');
  }
  return context;
};

export const FeedbackProvider = ({ children }) => {
  const [contextualFeedback, setContextualFeedback] = useState({
    isOpen: false,
    actionName: '',
    actionContext: '',
    position: 'bottom-right',
    autoClose: true
  });

  const showContextualFeedback = ({ 
    actionName, 
    actionContext = '', 
    position = 'bottom-right', 
    autoClose = true 
  }) => {
    setContextualFeedback({
      isOpen: true,
      actionName,
      actionContext,
      position,
      autoClose
    });
  };

  const hideContextualFeedback = () => {
    setContextualFeedback(prev => ({
      ...prev,
      isOpen: false
    }));
  };

  const value = {
    contextualFeedback,
    showContextualFeedback,
    hideContextualFeedback
  };

  return (
    <FeedbackContext.Provider value={value}>
      {children}
    </FeedbackContext.Provider>
  );
}; 